// extracted by mini-css-extract-plugin
export default {"wrapper":"custom-otp-input_wrapper__twIK6","otpWrapper":"custom-otp-input_otpWrapper__y-MLG","otpInput":"custom-otp-input_otpInput__06sKU"};